import axios from 'axios';

export const subscribe = (email, referer = '', source = '', advertiser = '', category = '') => {
    return new Promise((resolve, reject) => {
        return axios.post(
            `${process.env.API_BASE_URL}/v1/subscribers.json`, {
                email: email,
                referrer: referer || null,
                source: source || null,
                advertiser: advertiser || null,
                category: category || null
            }
        )
            .then(() => {
                resolve();
            })
            .catch(() => {
                reject();
            })
    });
};
